export default __webpack_public_path__ + "static/media/ordersActive.bb91c059.svg";